/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.2.24",
    versionName: "0.2.0-nightly.2026.2.24",
    versionChannel: "nightly",
    buildDate: "2026-02-24T00:12:07.504Z",
    commitHash: "d7d42835563bd97aef3eb08ab0227daaee061e8d",
};
